module.exports = __webpack_public_path__ + "static/lsac-c587d947d31a13a4b569ab23a066726a.png";